import { Link } from 'react-router-dom'
import { Minus, Plus, Trash2 } from 'lucide-react'
import { Seo } from '@/components/Seo'
import { useCartStore } from '@/lib/cart'
import { formatPrice } from '@/lib/money'

export default function Cart() {
  const items = useCartStore((s) => s.items)
  const updateQuantity = useCartStore((s) => s.updateQuantity)
  const removeItem = useCartStore((s) => s.removeItem)
  const total = useCartStore((s) => s.getTotalPrice())

  if (items.length === 0) {
    return (
      <>
        <Seo title="Giỏ hàng — LumiSkin" />
        <div data-upbo-src="src/pages/Cart.tsx:17" className="mx-auto w-full max-w-6xl px-6 py-24 text-center">
          <h1 data-upbo-src="src/pages/Cart.tsx:18" className="text-3xl font-semibold text-[#5f3f38]">Giỏ hàng đang trống</h1>
          <p data-upbo-src="src/pages/Cart.tsx:19" className="mt-3 text-[#9c7a72]">Chọn vài món bạn thích, rồi quay lại đây nhé.</p>
          <Link
            to="/cua-hang"
            className="mt-8 inline-block rounded-full bg-[#7a4f45] px-7 py-3 text-sm font-medium text-white transition-colors hover:bg-[#63403a]"
          >
            Đến cửa hàng
          </Link>
        </div>
      </>
    )
  }

  return (
    <>
      <Seo title="Giỏ hàng — LumiSkin" />

      <div data-upbo-src="src/pages/Cart.tsx:35" className="mx-auto w-full max-w-4xl px-6 py-16">
        <h1 data-upbo-src="src/pages/Cart.tsx:36" className="text-4xl font-semibold tracking-[-0.02em] text-[#5f3f38]">Giỏ hàng</h1>

        <ul data-upbo-src="src/pages/Cart.tsx:38" className="mt-10 divide-y divide-[#eedfda] border-y border-[#eedfda]">
          {items.map((item) => (
            <li data-upbo-src="src/pages/Cart.tsx:40" key={item.id} className="flex items-center gap-5 py-5">
              <div data-upbo-src="src/pages/Cart.tsx:41" className="h-20 w-20 shrink-0 overflow-hidden rounded-xl bg-[#f7ebe7]">
                {item.image && <img data-upbo-src="src/pages/Cart.tsx:42" src={item.image} alt={item.name} className="h-full w-full object-cover" />}
              </div>

              <div data-upbo-src="src/pages/Cart.tsx:45" className="min-w-0 flex-1">
                <p data-upbo-src="src/pages/Cart.tsx:46" className="truncate text-sm font-medium text-[#5f3f38]">{item.name}</p>
                <p data-upbo-src="src/pages/Cart.tsx:47" className="mt-1 text-sm text-[#9c7a72]">{formatPrice(item.price)}</p>
              </div>

              <div data-upbo-src="src/pages/Cart.tsx:50" className="flex items-center rounded-full border border-[#e0c8c1]">
                <button data-upbo-src="src/pages/Cart.tsx:51"
                  type="button"
                  aria-label="Giảm số lượng"
                  onClick={() => updateQuantity(item.id, Math.max(1, item.quantity - 1))}
                  className="flex h-9 w-9 items-center justify-center text-[#7a4f45]"
                >
                  <Minus className="h-3.5 w-3.5" />
                </button>
                <span data-upbo-src="src/pages/Cart.tsx:59" className="w-9 text-center text-sm text-[#5f3f38]">{item.quantity}</span>
                <button data-upbo-src="src/pages/Cart.tsx:60"
                  type="button"
                  aria-label="Tăng số lượng"
                  onClick={() => updateQuantity(item.id, item.quantity + 1)}
                  className="flex h-9 w-9 items-center justify-center text-[#7a4f45]"
                >
                  <Plus className="h-3.5 w-3.5" />
                </button>
              </div>

              <p data-upbo-src="src/pages/Cart.tsx:70" className="w-28 text-right text-sm font-semibold text-[#7a4f45]">
                {formatPrice(item.price * item.quantity)}
              </p>

              <button data-upbo-src="src/pages/Cart.tsx:74"
                type="button"
                aria-label={`Xoá ${item.name}`}
                onClick={() => removeItem(item.id)}
                className="text-[#c0a49d] transition-colors hover:text-[#c98b7e]"
              >
                <Trash2 className="h-4 w-4" />
              </button>
            </li>
          ))}
        </ul>

        <div data-upbo-src="src/pages/Cart.tsx:86" className="mt-8 flex items-center justify-between">
          <span data-upbo-src="src/pages/Cart.tsx:87" className="text-sm text-[#9c7a72]">Tạm tính</span>
          <span data-upbo-src="src/pages/Cart.tsx:88" className="text-2xl font-semibold text-[#7a4f45]">{formatPrice(total)}</span>
        </div>

        <Link
          to="/thanh-toan"
          className="mt-8 block rounded-full bg-[#7a4f45] py-3.5 text-center text-sm font-medium text-white transition-colors hover:bg-[#63403a]"
        >
          Tiến hành thanh toán
        </Link>
      </div>
    </>
  )
}
